import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RestorePasswordComponent } from './restore-password/restore-password.component';
import { LoginByEdsComponent } from './login-by-eds/login-by-eds.component';
import { SimpleLoginComponent } from './simple-login/simple-login.component';
import { LoginLayoutComponent } from './login-layout.component';
import { LoginBySmsComponent } from './login-by-sms/login-by-sms.component';

const routes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: '', component: SimpleLoginComponent,
      },
      {
        path: 'eds-login', component: LoginByEdsComponent,
      },
      {
        path: 'sms-login', component: LoginBySmsComponent,
      },
      {
        path: 'password-restore', component: RestorePasswordComponent,
      },
      {
        path: 'registration',
        loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
